import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { ReferralFraudFlag } from '../types';

const FLAG_LABEL: Record<ReferralFraudFlag, string> = {
  similar_contact: 'Kontak mirip referrer',
  same_signup_ip: 'IP pendaftaran sama',
  known_prospect: 'Sudah ada di database',
};

/**
 * Penanda, bukan vonis.
 *
 * Warnanya sengaja kuning dan bukan merah, dan tidak ada tombol apa pun di
 * sini: semua penanda punya penjelasan yang sah — suami-istri satu warung, dua
 * toko satu wifi. Yang dilakukannya hanya meminta seseorang melihat lebih
 * dekat. Menampilkannya seperti pelanggaran akan membuat admin menolak referral
 * yang sebetulnya sah.
 */
const ReferralFlagBadges: React.FC<{ flags?: ReferralFraudFlag[] }> = ({ flags }) => {
  if (!flags || flags.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1 mt-1">
      {flags.map((flag) => (
        <span
          key={flag}
          title="Penanda otomatis — perlu diperiksa, bukan berarti melanggar"
          className="inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-medium rounded bg-yellow-100 text-yellow-800 border border-yellow-300"
        >
          <AlertTriangle className="h-3 w-3" />
          {FLAG_LABEL[flag] ?? flag}
        </span>
      ))}
    </div>
  );
};

export default ReferralFlagBadges;
